<template lang="pug">
box
  page-title(slot="page-title", title="Cadastro")
  load-manager.scrollable(slot="content", :loading="loading", :errors="errors")
    .container.grid-lg(v-if="cadastro")
      .columns(v-if="isMobiliario")
        .column.col-12.my-2
          text-output(
            :label="'pessoa.razao_social' | tModel",
            :text="cadastro.pessoa.razao_social"
          )
        .column.col-4.col-xs-12.my-2
          text-output(
            :label="'pessoa.cpf_cnpj' | tModel",
            :text="cadastro.pessoa.cpf_cnpj | cpfCnpj"
          )
        .column.col-4.col-xs-12.my-2
          text-output(
            :label="'pessoa.fone' | tModel",
            :text="cadastro.pessoa.fone | phone"
          )
        .column.col-4.col-xs-12.my-2
          text-output(
            :label="'pessoa.email' | tModel",
            :text="cadastro.pessoa.email"
          )
      .divider(v-if="isMobiliario")
      .columns
        .column.col-4.col-sm-6.col-xs-12.my-2
          text-output(
            :label="'cadastro.numero' | tModel",
            :text="cadastro.numero"
          )
          text-output(:label="'cadastro.zona' | tModel", :text="cadastro.zona")
        .column.col-4.col-sm-6.col-xs-12.my-2
          text-output(
            :label="'cadastro.tipo' | tModel",
            :text="`enums.db.enum_cadastro_tipo.${cadastro.tipo}` | translate"
          )
          text-output(
            :label="'cadastro.quadra' | tModel",
            :text="cadastro.quadra"
          )
        .column.col-4.col-sm-6.col-xs-12.my-2
          text-output(
            :label="'cadastro.situacao' | tModel",
            :text="cadastro.situacao.descricao"
          )
          text-output(:label="'cadastro.lote' | tModel", :text="cadastro.lote")
        .column.col-12
          text-output(
            :label="'cadastro.endereco' | tModel",
            :text="cadastro.endereco_formatado",
            :ellipsis="false"
          )
      div(v-if="cadastro.socios && cadastro.socios.length")
        .divider.text-center(data-content="Sócios / Proprietários")
        .columns
          .column.col-6.col-sm-12.my-2(
            v-for="socio in cadastro.socios",
            :key="socio.id"
          )
            socio(:socio="socio")
      div(
        v-if="cadastro.cadastro_imobiliario && cadastro.cadastro_imobiliario.id"
      )
        .divider.text-center(data-content="Localização do cadastro")
        v-map.map(
          :api-key="mapKey",
          :zoom="15",
          :options="mapOptions",
          :center="cadastroLocation"
        )
          v-marker(:position="cadastroLocation", :options="markerOptions")
      .d-flex.float-right.py-2.my-2(slot="action")
        router-link.btn.btn-link.btn-lg(
          :to="{ name: 'app.cadastro.docs', params: { id: $route.params.id } }"
        )
          i.fa.fa-flag-o
          span &nbsp;Histórico de Documentos
        router-link.btn.btn-link.btn-lg(
          :to="{ name: 'app.carnes.carne', params: { id: $route.params.id } }"
        )
          i.fa.fa-dollar
          span &nbsp;Carnê
        router-link.btn.btn-link.btn-lg(
          :to="{ name: 'app.cadastro.debitos', params: { id: $route.params.id } }"
        )
          i.fa.fa-money
          span &nbsp;Débitos
      router-view
</template>

<script>
import showMixin, { defaultStoreImports } from "@/mixins/show";
import Cadastro from "@/models/Cadastro";
import Socio from "./Socio";
import envs from "@/config/envs";

export default {
  vuex: { cadastros: defaultStoreImports },
  computed: {
    socios() {
      if (this.isMobiliario) {
        return this.cadastro.pessoas.filter(
          (i) => i.cpf_cnpj !== this.cadastro.pessoa.cpf_cnpj
        );
      }
      return this.cadastro.pessoas;
    },
    isMobiliario() {
      return this.cadastro.tipo === "mobiliario";
    },
    cadastroLocation() {
      const { latitude, longitude } = this.cadastro.cadastro_imobiliario;
      return { lat: latitude, lng: longitude };
    },
    mapKey() {
      return envs.googleMapsApiKey;
    },
    cadastro() {
      return this.current ? new Cadastro(this.current) : null;
    },
    mapOptions() {
      return { disableDefaultUI: true, gestureHandling: "cooperative" };
    },
    markerOptions() {
      return { icon: require("@/assets/map-marker.png") };
    },
  },
  components: { Socio },
  mixins: [showMixin],
};
</script>

<style lang="stylus" scoped>
.map {
  height: 400px;
  border-radius: 5px;
  width: 100%;
  margin: 1rem 0;
}
</style>
